import React from "react";
import Header from "../Components/Home/Header.tsx";
import Hero from "../Components/Home/Hero.tsx";
import About from "../Components/Home/About.tsx";
import Projects from "../Components/Home/Projects.tsx";
import Team from "../Components/Home/Team.tsx";
import Footer from "../Components/Home/Footer.tsx";

type Props = {};

const Home = (props: Props) => {
  return (
    <div style={{ backgroundColor: "#F5F6F4" }}>
      <Header />
      <Hero />
      <About />
      <Projects />
      <Team />
      <Footer />
    </div>
  );
};

export default Home;
